var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('main-header'),_c('transition',{attrs:{"name":"el-fade-in"}},[_c('router-view',{staticClass:"main-content"})],1),_c('main-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }